<template>
    <div>
        <title-component></title-component>
        <div>
            <b-form>
                <div class="row">

                    <div class="col-12 col-sm-6">
                        <card-title-component :title="$t('profile.basicInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="firstname-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.firstname')"
                                                  label-for="firstname-input">
                                        <b-form-input id="firstname-input"
                                                      name="firstname-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localFirstname"
                                                      required
                                                      :placeholder="$t('profile.basicInformation.firstname')"
                                                      v-validate="'required'"
                                                      v-bind:class="{'o-form--state-danger': errors.has('firstname-input-name')}">
                                        </b-form-input>
                                        <span>{{ errors.first('firstname-input-name') }}</span>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="lastname-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.lastname')"
                                                  label-for="lastname-input">
                                        <b-form-input id="lastname-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localLastname"
                                                      required
                                                      :placeholder="$t('profile.basicInformation.lastname')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="address-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.address')"
                                                  label-for="address-input">
                                        <b-form-input id="address-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localAddress"
                                                      required
                                                      :placeholder="$t('profile.basicInformation.address')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="address-extra-line-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.addressExtraInformation')"
                                                  label-for="address-extra-line-input">
                                        <b-form-input id="address-extra-line-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localExtraAddressLine"
                                                      required
                                                      :placeholder="$t('profile.basicInformation.addressExtraInformation')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="zipcode-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.zipcode')"
                                                  label-for="zipcode-input">
                                        <b-form-input id="firstname-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localZipcode"
                                                      required
                                                      :placeholder="$t('profile.basicInformation.zipcode')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="city-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.city')"
                                                  label-for="city-input">
                                        <b-form-input id="city-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localCity"
                                                      required
                                                      :placeholder="$t('profile.basicInformation.city')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <card-title-component :title="$t('profile.contactInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="email-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.email')"
                                                  label-for="email-input">
                                        <b-form-input id="email-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localEmail"
                                                      required
                                                      :placeholder="$t('profile.contactInformation.email')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="mobile-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.mobile')"
                                                  label-for="mobile-input">
                                        <b-form-input id="mobile-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localMobile"
                                                      required
                                                      :placeholder="$t('profile.contactInformation.mobile')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="phone-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.phone')"
                                                  label-for="phone-input">
                                        <b-form-input id="phone-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localPhone"
                                                      required
                                                      :placeholder="$t('profile.contactInformation.phone')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="website-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.website')"
                                                  label-for="website-input">
                                        <b-form-input id="website-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localWebsite"
                                                      required
                                                      :placeholder="$t('profile.contactInformation.website')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <card-title-component :title="$t('profile.detailInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="profession-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.profession')"
                                                  label-for="profession-input">
                                        <b-form-input id="profession-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localProfession"
                                                      required
                                                      :placeholder="$t('profile.detailInformation.profession')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="employer-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.employer')"
                                                  label-for="employer-input">
                                        <b-form-input id="employer-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localEmployer"
                                                      required
                                                      :placeholder="$t('profile.detailInformation.employer')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="birthdate-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.birthdate')"
                                                  label-for="birthdate-input">
                                        <datepicker v-model="localBirthdate" id="birthdate-input" class="o-form" :format="'dd.MM.yyyy'" :language="this.getLanguage()"></datepicker>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="ahv-number-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.ahvNumber')"
                                                  label-for="ahv-number-input">
                                        <b-form-input id="ahv-number-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localAHVNumber"
                                                      required
                                                      :placeholder="$t('profile.detailInformation.ahvNumber')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="place-of-origin-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.placeOfOrigin')"
                                                  label-for="place-of-origin-input">
                                        <b-form-input id="place-of-origin-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localPlaceOfOrigin"
                                                      required
                                                      :placeholder="$t('profile.detailInformation.placeOfOrigin')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="marital-status-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.maritalStatus')"
                                                  label-for="marital-status-input">
                                        <b-form-input id="marital-status-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localMaritalStatus"
                                                      required
                                                      :placeholder="$t('profile.detailInformation.maritalStatus')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="health-insurance-1-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.healthInsurance1')"
                                                  label-for="health-insurance-1-input">
                                        <b-form-input id="health-insurance-1-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localHealthInsurance1"
                                                      required
                                                      :placeholder="$t('profile.detailInformation.healthInsurance1')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="health-insurance-2-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.healthInsurance2')"
                                                  label-for="health-insurance-2-input">
                                        <b-form-input id="health-insurance-2-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localHealthInsurance2"
                                                      required
                                                      :placeholder="$t('profile.detailInformation.healthInsurance2')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <card-title-component :title="$t('profile.furtherInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.organDonor')"
                                                  label-for="organdonor-input">
                                        <b-form-checkbox id="organdonor-input-id"
                                                         v-model="localOrganDonor">
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.patientsProvision')"
                                                  label-for="patientsProvision-input">
                                        <b-form-checkbox id="patientsProvision-input-id"
                                                         v-model="localPatientsProvision">
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="religion-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.religion')"
                                                  label-for="religion-input">
                                        <b-form-input id="religion-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localReligion"
                                                      required
                                                      :placeholder="$t('profile.furtherInformation.religion')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="confession-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.confession')"
                                                  label-for="confession-input">
                                        <b-form-input id="confession-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="localConfession"
                                                      required
                                                      :placeholder="$t('profile.furtherInformation.confession')">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-form>
        </div>
        <div class="row">
            <div class="col button-div">
                <b-button class="save-button o-button" v-on:click="save">
                    {{$t('profile.saveButton')}}
                </b-button>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        PROFILE_ACTION_GET_PROFILE,
        PROFILE_ACTION_SAVE_PROFILE,
        PROFILE_GETTER,
        PROFILE_MUTATION_SINGLE_ENTRY,
        PROFILE_NAMESPACE
    } from '../store/modules/profile-types'
    import {PROFILE_FIRSTNAME} from '../models/profile'
    import TitleComponent from './shared/TitleComponent'
    import CardTitleComponent from './ui/card/CardTitleComponent'
    import Datepicker from 'vuejs-datepicker'
    import {de, en} from 'vuejs-datepicker/dist/locale'
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'Profile',
        metaInfo () { return { title: i18n.t('profile.meta') } },
        components: {
            'title-component': TitleComponent,
            'card-title-component': CardTitleComponent,
            'datepicker': Datepicker
        },
        computed: {
            ...mapGetters(PROFILE_NAMESPACE, {
                profile: PROFILE_GETTER
            }),
            localFirstname: {
                get () { return this.profile.firstname },
                set (value) { this.updateProfile({[PROFILE_FIRSTNAME]: value}) }
            },
            localLastname: {
                get () { return this.profile.lastname },
                set (value) { this.updateProfile({lastname: value}) }
            },
            localAddress: {
                get () { return this.profile.address },
                set (value) { this.updateProfile({address: value}) }
            },
            localExtraAddressLine: {
                get () { return this.profile.extraAddressLine },
                set (value) { this.updateProfile({extraAddressLine: value}) }
            },
            localZipcode: {
                get () { return this.profile.zipcode },
                set (value) { this.updateProfile({zipcode: value}) }
            },
            localCity: {
                get () { return this.profile.city },
                set (value) { this.updateProfile({city: value}) }
            },
            localEmail: {
                get () { return this.profile.email },
                set (value) { this.updateProfile({email: value}) }
            },
            localMobile: {
                get () { return this.profile.mobile },
                set (value) { this.updateProfile({mobile: value}) }
            },
            localPhone: {
                get () { return this.profile.phone },
                set (value) { this.updateProfile({phone: value}) }
            },
            localWebsite: {
                get () { return this.profile.website },
                set (value) { this.updateProfile({website: value}) }
            },
            localProfession: {
                get () { return this.profile.profession },
                set (value) { this.updateProfile({profession: value}) }
            },
            localEmployer: {
                get () { return this.profile.employer },
                set (value) { this.updateProfile({employer: value}) }
            },
            localAHVNumber: {
                get () { return this.profile.ahvNumber },
                set (value) { this.updateProfile({ahvNumber: value}) }
            },
            localBirthdate: {
                get () { return this.profile.birthdate },
                set (value) { this.updateProfile({birthdate: value}) }
            },
            localPlaceOfOrigin: {
                get () { return this.profile.placeOfOrigin },
                set (value) { this.updateProfile({placeOfOrigin: value}) }
            },
            localMaritalStatus: {
                get () { return this.profile.maritalStatus },
                set (value) { this.updateProfile({maritalStatus: value}) }
            },
            localHealthInsurance1: {
                get () { return this.profile.healthInsurance1 },
                set (value) { this.updateProfile({healthInsurance1: value}) }
            },
            localHealthInsurance2: {
                get () { return this.profile.healthInsurance2 },
                set (value) { this.updateProfile({healthInsurance2: value}) }
            },
            localOrganDonor: {
                get () { return this.profile.organDonor },
                set (value) { this.updateProfile({organDonor: value}) }
            },
            localPatientsProvision: {
                get () { return this.profile.patientsProvision },
                set (value) { this.updateProfile({patientsProvision: value}) }
            },
            localReligion: {
                get () { return this.profile.religion },
                set (value) { this.updateProfile({religion: value}) }
            },
            localConfession: {
                get () { return this.profile.confession },
                set (value) { this.updateProfile({confession: value}) }
            }
        },
        methods: {
            ...mapMutations(PROFILE_NAMESPACE, {
                updateProfile: PROFILE_MUTATION_SINGLE_ENTRY
            }),
            ...mapActions(PROFILE_NAMESPACE, {
                loadProfile: PROFILE_ACTION_GET_PROFILE,
                saveProfile: PROFILE_ACTION_SAVE_PROFILE
            }),
            save () {
                this.saveProfile(this.profile)
            },
            getLanguage () {
                if (this.$i18n.locale === 'en') {
                    return en
                } else {
                    return de
                }
            }
        },
        created () {
            this.loadProfile()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/custom/vars';

    .save-button {
        border-radius: 0;
        border: 0px;
        float: right;
    }

</style>



// WEBPACK FOOTER //
// src/components/ProfileComponent.vue